import { atom } from '@reatom/framework'

import type { BlockHash } from '../model'

export const blockHashAtom = atom<BlockHash.BlockHash | undefined>(
  undefined,
  'blockHashAtom',
)
